<div *ngIf="successMessage" class="alert alert-success" role="alert">
	<mat-icon>thumb_up</mat-icon> &nbsp;
	<label style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{successMessage}}
	</label>
</div>

<div *ngIf="errorMessage" class="alert alert-danger" role="alert">
	<label style="vertical-align: text-bottom; margin-bottom: 0rem;">
		{{errorMessage}}
	</label>
</div>

<div class="row_1 board_screen">
	<div class="top_grid_agg">
		<div class="content">
			<div style="width: 50%; justify-content: left; display: flex;">
				<label class="drpdwn_board_label">Board</label>

				<select [(ngModel)]="selected_board" [ngModelOptions]="{standalone: true}"
					class="drpdwn_board" (change)="onBoardChange()">
					<option value="0" selected>ALL</option>
					<option *ngFor="let board of boardData" [value]="board.boardID">
						{{board.description}}
					</option>
				</select>

				<label class="drpdwn_team_label">Team</label>

				<select [(ngModel)]="selected_team" [ngModelOptions]="{standalone: true}"
					class="drpdwn_team" (change)="onTeamChange()">
					<option value="0" selected>ALL</option>
					<option *ngFor="let team of teamData" [value]="team.teamID">
						{{team.description}}
					</option>
				</select>

				<mat-slide-toggle class="slide_completed" [(ngModel)]="activate_completed"
					(change)="onCompletedToggle()">Completed</mat-slide-toggle>
			</div>

			<div style="width: 50%; justify-content: right; display: flex;">
				<button class="refresh_button" (click)="refresh()">REFRESH</button>
				<img src="../../../assets/images/Line 8225.svg" class="line">
				<button routerLink="/mytasks" class="add_button">MY TASKS</button>
				<button routerLink="/newtask" class="add_button">NEW TASK</button>
				<img src="../../../assets/images/Line 8225.svg" class="line">
				<button class="calendar_button" (click)="updateCalendar()">UPDATE CALENDAR</button>
				<button class="export_button" (click)="onBtExport()">EXPORT</button>
			</div>
		</div>

		<div class="grid-agg">
			<ag-grid-angular #agGrid id="board-table" [ngStyle]="{'height': dynamicHeight + 'px',
				'width':'100%' , 'font-family':'Roboto'}" class="ag-theme-balham" [pagination]="setPagination"
				[columnDefs]="columnDefs" [rowData]="rowData" [defaultColDef]="defaultColDef"
				[paginationPageSize]="paginationPageSize" (gridReady)="onGridReady($event)"
				(gridSizeChanged)="onGridSizeChanged($event)" [theme]="'legacy'" [getRowHeight]="getRowHeight"
				[context]="context" [gridOptions]="gridOptions"
				(filterChanged)="onFilterChanged($event)"></ag-grid-angular>

			<div class="custom-pagination" *ngIf="totalRecords > 0">
				<div class="left">
					<span class="records-per-page">
						<span>Records/Page : </span>
						<select [(ngModel)]="rpPage" (change)="rppChanged($event)">
							<option *ngFor="let size of pgDropDown" [value]="size.value">{{ size.value }}</option>
						</select>
					</span>
				</div>
				<div class="right">
					<span class="viewing-records">
						<span class="w-600">{{sRecord}}</span> to <span class="w-600">{{eRecord}}</span> of <span
							class="w-600">{{totalRecords}}</span>
						<button (click)="goToFirstPage()" [disabled]="getCurrentPage() === true"><i
								class="fa-solid fa-backward-fast"
								[ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
						<button (click)="goToPreviousPage()" [disabled]="getCurrentPage() === true"><i
								class="fa-solid fa-backward-step"
								[ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
						<span>Page <span class="w-600">{{cPage}}</span> of <span class="w-600">{{tPage}}</span></span>
						<button (click)="goToNextPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-step"
								[ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
						<button (click)="goToLastPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-fast"
								[ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
					</span>
				</div>
			</div>


			<div class="symbol_label">
				<div class="legend-item">
					<img src="../../../assets/images/Ellipse 1.svg">
					<label>Completed ontime</label>
				</div>
				<div class="legend-item">
					<img src="../../../assets/images/times-solid.svg">
					<label>Completed Late</label>
				</div>
				<div class="legend-item">
					<img src="../../../assets/images/ban-solid.svg">
					<label>Completed Forgot to mark</label>
				</div>
				<div class="legend-item">
					<img style="width: 17px !important;height: 17px" src="../../../assets/images/Rectangle 18119.svg">
					<label>Past Due</label>
				</div>
				<div class="legend-item">
					<img style="width: 17px !important;height: 17px" src="../../../assets/images/Rectangle 18120.svg">
					<label>Unassigned</label>
				</div>
				<div class="legend-item">
					<img style="width: 17px !important;height: 17px" src="../../../assets/images/Rectangle 18121.svg">
					<label>New Task</label>
				</div>
				<div class="legend-item">
					<a class="square"></a>
					<label class="notask-label">No Task</label>
				</div>
			</div>

		</div>
	</div>
</div>